interface SubmittedCardProps {
  text: string;
  revealed?: boolean;
  selected?: boolean;
  onClick?: () => void;
  delay?: number;
  number?: number;
  testId?: string;
}

export function SubmittedCard({ text, revealed, selected, onClick, number = 1, testId }: SubmittedCardProps) {
  return <button type="button" onClick={onClick} disabled={!onClick} data-testid={testId}
    data-revealed={revealed ? 'true' : 'false'} data-selected={selected ? 'true' : 'false'}
    aria-pressed={revealed && onClick ? Boolean(selected) : undefined}
    aria-label={revealed ? `Answer ${number}: ${text}` : `Answer ${number}, face down`}
    className={`answer-paper ${revealed ? 'is-revealed' : 'is-facedown'} ${selected ? 'is-selected' : ''}`}>
    <span className="answer-number">{String(number).padStart(2, '0')} / {selected ? 'Your pick' : revealed ? 'Answer' : 'Face down'}</span>
    {revealed ? <span className="answer-copy">{text}</span> : <span className="answer-back-mark" aria-hidden="true">Deck<br />After<br />Dark.</span>}
    <span className="answer-footer">{selected ? '✓ Selected' : revealed ? 'Deck After Dark' : 'Ready to reveal'}</span>
  </button>;
}
